import React, { useEffect, useState, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import TableContainer from "../../../components/Common/TableContainer"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    FormFeedback,
    Input,
    Form,
} from "reactstrap"
import toast from "react-hot-toast"
import Breadcrumbs from "components/Common/Breadcrumb"
import Select from "react-select"
import * as Yup from "yup"
import { useFormik } from "formik"
import Spinners from "components/Common/Spinner"
import {
    getAllEvents,
    getAllTicketGroup,
    createTicketGroup,
    updateTicketGroup,
    deleteTicketGroup,
} from "api";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledTooltip } from "reactstrap"
import DeleteModal from "components/Common/DeleteModal";
import { getUserRole } from "utils/storage";

const TicketGroup = () => {
    const navigate = useNavigate()

    //meta title
    document.title = "Ticket Group List | EventoX"
    const [events, setEvents] = useState([])
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [allTicketGroupList, setAllTicketGroupList] = useState([]);
    const [ticketGroupList, setTicketGroupList] = useState([]);
    const [modal, setModal] = useState(false)
    const [isSlotRequired, setIsSlotRequired] = useState(false)
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState(null)
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [statusOptions,setStatusOptions]=useState([
        { value: "active", label: "Open" },
        { value: "inactive", label: "Closed" },
    ])


    const getEvents = async () => {
        try {
            const response = await getAllEvents()
            setEvents(response)
        } catch (error) {
            console.log(error)
        }
    }
    const eventOptions = useMemo(() => {
        return events.map(event => ({
            value: event.slugId,
            label: event.eventName,
        }))
    }, [events])

    const getTicketGroups = async () => {
        setIsLoading(true);
        try {
            const response = await getAllTicketGroup();
            setAllTicketGroupList(response);
            const role = getUserRole();
            if (role === 1 || role === '1') {
                setTicketGroupList(response);
            } else {
                setTicketGroupList([]);
            }
        } catch (error) {
            console.error("Failed to fetch ticket groups:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getTicketGroupByEvent = async (slug) => {
        try {
            const filtered = allTicketGroupList.filter((group) => group.slugId === slug);
            setTicketGroupList(filtered);
        } catch (error) {
            console.error("Error filtering ticket groups:", error);
            toast.error("Something went wrong while filtering ticket groups!");
        }
    };
    const handleClickedEdit = (data) => {
    setIsEdit(true);
    setEditData(data);
    validation.setValues({
        groupName: data.groupName || "",
        isSlotRequired: data.isSlotRequired || false,
        slugId: data.slugId || "",
        status: data.status || "",
        ticketOrder: data.ticketOrder || "",
    });
    toggle(); 
}

  const handleGroupTicketChange = ()=>{
    setIsGroupTicket(!isGroupTicket)

  }
  const onClickDelete = (data) => {
    setSelectedGroup(data);
    setDeleteModal(true);
  };
  
  const handleDeleteGroup = async () => {
    try {
      await deleteTicketGroup(selectedGroup.id);
      toast.success("Ticket group deleted successfully");
      getTicketGroups(); // refresh the list
    } catch (error) {
      toast.error("Failed to delete ticket group");
      console.error(error);
    } finally {
      setDeleteModal(false);
      setSelectedGroup(null);
    }
  };
  
    
    useEffect(() => {
        getEvents();
        getTicketGroups();
    }, []);

    useEffect(() => {
        const handleTicketGroups = async () => {
            if (selectedEvent && selectedEvent.value) {
                if (selectedEvent.value === "ALL") {
                    setTicketGroupList(allTicketGroupList);
                } else {
                    await getTicketGroupByEvent(selectedEvent.value);
                }
            }
        };

        handleTicketGroups();
    }, [selectedEvent, allTicketGroupList]);



const toggle = () => {
    setModal(!modal);
    if (modal) { 
        validation.resetForm();
        setIsEdit(false);
        setEditData(null);
    }
}

    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            groupName: "",
            isSlotRequired: false,
            slugId: "",
            status: "",
        },
        validationSchema: Yup.object({
            groupName: Yup.string().required("Please Enter Group Name"),
            slugId: Yup.string().required("Please Select Event"),
            isSlotRequired: Yup.boolean(),
            status: Yup.string().required("Please status"),
        }),
        onSubmit: async (values) => {
            values.isSlotRequired = isSlotRequired;
            setIsLoading(true)
            let res;

if (isEdit && editData) {
  res = await updateTicketGroup(editData.id, values);
} else {
  res = await createTicketGroup(values);
}

if (res) {
  toast.success(isEdit ? "Ticket group updated successfully" : "Ticket group added successfully");
  getTicketGroups(); 
  toggle(); 
  validation.resetForm(); 
  setIsSlotRequired(false);
  setIsEdit(false);
} else {
  toast.error("Something went wrong while processing the request.");
}
        },
    })

    const columns = useMemo(
        () => [
            {
                header: "Ticket Group Name",
                accessorKey: "groupName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Event Slug",
                accessorKey: "slugId",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Is Slot Required",
                accessorKey: "isSlotRequired",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Status",
                accessorKey: "status",
                enableColumnFilter: false,
                enableSorting: true,
                cell: cell => {
                    return (
                        <div>
                            {cell.getValue() === "active" ? (
                                <span className="badge badge-soft-primary font-size-11 m-1">
                                    {cell.getValue()}
                                </span>
                            ) : (
                                <span className="badge badge-soft-danger font-size-11 m-1">
                                    {cell.getValue()}
                                </span>
                            )}
                        </div>
                    )
                },
            },
            {
                header: "Created",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                    header: 'Action',
                    cell: (cellProps) => {
                      return (
                        <UncontrolledDropdown>
                          <DropdownToggle tag="a" className="card-drop">
                            <i className="mdi mdi-dots-horizontal font-size-18"></i>
                          </DropdownToggle>
            
                          <DropdownMenu className="dropdown-menu-end">
            
                            <DropdownItem
                              onClick={() => {
                                const data = cellProps.row.original;
                                handleClickedEdit(data);
                              }}>
                              <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
                              Edit
                              <UncontrolledTooltip placement="top" target="edittooltip">
                                Edit
                              </UncontrolledTooltip>
                            </DropdownItem>
                            <DropdownItem
                  onClick={() => {
                    const data = cellProps.row.original;
                    onClickDelete(data);
                  }}>
                  <i className="mdi mdi-trash-can font-size-16 text-danger me-1" id="deletetooltip"></i>
                  Delete
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      );
                    }
                  },
        ],
        []
    )
    const handleClickNew = () => {
        toggle()
    }


    return (
        <React.Fragment>
            <DeleteModal
                          show={deleteModal}
                          onDeleteClick={handleDeleteGroup}
                          onCloseClick={() => setDeleteModal(false)}/>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Ticket Groups List" />

                    <Row>
                        {isLoading ? (
                            <Spinners setLoading={setIsLoading} />
                        ) : (
                            <Col lg="12">
                                <Card>
                                    <CardBody>
                                        <Row className="mb-3">
                                            <Col xl="5">
                                                <div className="col-md-12">
                                                    <Select
                                                        value={selectedEvent}
                                                        placeholder="Select Event"
                                                        onChange={data => setSelectedEvent(data)}
                                                        options={[
                                                            { value: "ALL", label: "All Events" },
                                                            ...events.map(event => ({
                                                                value: event.slugId,
                                                                label: event.eventName,
                                                            })),
                                                        ]}
                                                        width="100%"
                                                        className="select2-selection"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <TableContainer
                                                columns={columns}
                                                data={ticketGroupList || []}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Search..."
                                                isCustomPageSize={true}
                                                isAddButton={true}
                                                handleUserClick={handleClickNew}
                                                buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                                                buttonName="New Ticket Group"
                                                tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                pagination="pagination"
                                            />
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        )}

                        <Modal isOpen={modal} toggle={toggle}>
                            <ModalHeader toggle={toggle} tag="h4">
                                 {!!isEdit ? "Edit Ticket group" :"Add New Ticket Group"}
                            </ModalHeader>
                            <ModalBody>
                                <Form
                                    onSubmit={e => {
                                        e.preventDefault()
                                        validation.handleSubmit()
                                        return false
                                    }}
                                >
                                    <Row>
                                        <Col xs={12}>
                                            <div className="mb-3">
                                            <Select
                                            name="slugId"
                                            options={eventOptions}
                                            placeholder="Select Event"
                                            value={eventOptions.find(o => o.value === validation.values.slugId) || null}
                                            onChange={option => validation.setFieldValue("slugId", option?.value || "")}
                                            onBlur={() => validation.setFieldTouched("slugId", true)}
                                            className={validation.touched.slugId && validation.errors.slugId ? "is-invalid" : ""}
                                            classNamePrefix="rs"
                                            styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                                            />
             
                                            {validation.touched.slugId && validation.errors.slugId ? (
                                            <FormFeedback type="invalid" className="d-block">
                                                {validation.errors.slugId}
                                            </FormFeedback>
                                            ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <Label className="form-label">Group Name</Label>
                                                <Input
                                                    name="groupName"
                                                    type="text"
                                                    placeholder="Group Name"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.groupName || ""}
                                                    invalid={
                                                        validation.touched.groupName && validation.errors.groupName
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validation.touched.groupName && validation.errors.groupName ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.groupName}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                            <div className="form-check mb-3">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="isSlotRequired"
                                                    onChange={() => setIsSlotRequired(!isSlotRequired)}
                                                    defaultChecked={isSlotRequired}
                                                    value={isSlotRequired}

                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="isSlotRequired"
                                                >
                                                    Is Slot Required?
                                                </label>
                                            </div>
                                            
                    {/* <div className="mb-3">
                        <Label className="form-label">Ticket Order No</Label>
                        <Input
                          name="ticketOrder"
                          label="Order"
                          type="text"
                          placeholder="Enter the order no .Eg: 1,2,3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.ticketOrder || ""}
                          invalid={
                            validation.touched.ticketOrder &&
                              validation.errors.ticketOrder
                              ? true
                              : false
                          }

                        />
                        {validation.touched.ticketOrder &&
                          validation.errors.ticketOrder ? (
                          <FormFeedback type="invalid">
                            {validation.errors.ticketOrder}
                          </FormFeedback>
                        ) : null}

                      </div> */}

                                        <div className="mb-3">
                                        <Label htmlFor="project-status-input">Status</Label>
                                        <Select
                                            id="project-status-input"
                                            name="status"
                                            options={statusOptions}
                                            placeholder="Select Status"
                                            value={statusOptions.find(opt => opt.value === validation.values.status) || null}
                                            onChange={option => validation.setFieldValue("status", option?.value || "")}
                                            onBlur={() => validation.setFieldTouched("status", true)}
                                            className={validation.touched.status && validation.errors.status ? "is-invalid" : ""}
                                            classNamePrefix="rs"
                                            styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                                        />

                                        {validation.touched.status && validation.errors.status ? (
                                            <FormFeedback type="invalid" className="d-block">
                                            {validation.errors.status}
                                            </FormFeedback>
                                        ) : null}
                                        </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="text-end">
                                                <button
                                                    type="submit"
                                                    className="btn btn-success save-user"
                                                >
                                                    {isLoading ? "Loading...." : "Save"}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </ModalBody>
                        </Modal>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(TicketGroup)